export default "__VITE_PUBLIC_ASSET__7f86070c__"